import { cn } from "@/lib/utils";
/** Thin bottom strip (Kraken Pro style): connection state and data notes. Tablet and up; phones show the state as a dot in the top bar. */
export function StatusBar({ online }: { online: boolean | null }) {
	const label = online == null ? "Connecting" : online ? "Online" : "Offline";
	return (
		<footer className="sticky bottom-0 z-30 flex h-7 items-center justify-between border-t border-separator bg-background px-4 text-2xs text-muted">
			<div className="flex items-center gap-1.5">
				<span
					className={cn(
						"size-1.5 rounded-full",
						online == null ? "bg-warning" : online ? "bg-profit" : "bg-loss",
					)}
				/>
				<span className={cn(online === false && "text-loss")}>{label}</span>
			</div>
			<span className="hidden truncate sm:inline">Binance USDT-M · all R figures net of fees, slippage and funding</span>
		</footer>
	);
}
